export enum ActionType {
    UpdateRole = "UPDATE_ROLE",
    UpdateAppState = "UPDATE_APP_STATE",
    UpdateSideMenu = "UPDATE_SIDE_MENU",
    UpdateTrainingState = "UPDATE_TRAINING_STATE",
    ClearTrainingState = "CLEAR_TRAINING_STATE",
    UpdateNavState = "UPDATE_NAV_STATE",
    ClearNavStack = "CLEAR_NAV_STACK",
    UpdateInventory = "UPDATE_INVENTORY",
    UpdateInventoryType = "INVENTORY_TYPE",
    UpdateLoading = "UPDATE_LOADING"

}